import CustomerPage from "./components/CustomerPage";

export default CustomerPage;



// WEBPACK FOOTER //
// ./src/customer/index.js